import { SvgData } from "../../model/SvgData";
import { ModuleContainerGeneric } from "../ModuleContainerGeneric";
import { Iconos } from "./Iconos";
import { MAX_CANT_ICONOS_GRANDES } from "../../constants/data";
import { GenericComponentProps } from "../../model/GenericComponentProps";
import { ErrorBoundary } from "../ErrorBoundary";

export function IconosGrandes(props: GenericComponentProps<SvgData>) {
  if (!props?.data || props.data.length === 0) return <></>;

  //el gestor deberia validar este tope tambien
  const filteredData = props.data.slice(0, MAX_CANT_ICONOS_GRANDES);

  return (
    <ErrorBoundary>
      <ModuleContainerGeneric
        display="flex"
        paddingY={"0px !important"}
        backgroundColor={props.backgroundColor || "secondary.0"}
      >
        <Iconos iconos={filteredData} />
      </ModuleContainerGeneric>
    </ErrorBoundary>
  );
}
